import { getAmplitudeInstance } from '../amplitudeHelpers';
import CustomRouteActionTaken from '../enums/CustomRouteActionTaken';
import CustomRouteMode from '../enums/CustomRouteMode';
import CustomRoutePOI from '../enums/CustomRoutePOI';

type logCustomRouteUpdatedParams = {
  custom_route_action_taken: CustomRouteActionTaken;
  custom_route_mode?: CustomRouteMode;
  poi_add_location?: CustomRoutePOI;
  smart_route_menu_activity?: boolean;
  split_menu_activity?: boolean;
};

/**
 * Catch-all event that encompasses all route building interactions between starting and saving, including dragging, tapping, drawing, and route assistant split submission.
 * @param params - Attributes to log with the amplitude event
 * @param params.custom_route_action_taken - Action that the user took when building a custom route
 * @param params.custom_route_mode - Mode the user was in when the custom route updated (tap, free draw, smart draw)
 * @param params.poi_add_location - For 'add POI to route' action only
 * @param params.smart_route_menu_activity - TRUE if the updated action comes from the smart route menu
 * @param params.split_menu_activity - TRUE if the updated action comes from the split route menu
 */
const logCustomRouteUpdated = (
  { custom_route_action_taken, custom_route_mode, poi_add_location, smart_route_menu_activity, split_menu_activity }: logCustomRouteUpdatedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'custom route updated',
    {
      'custom route action taken': custom_route_action_taken,
      'custom route mode': custom_route_mode,
      'poi add location': poi_add_location,
      'smart route menu activity': smart_route_menu_activity,
      'split menu activity': split_menu_activity
    },
    callback
  );
};

export default logCustomRouteUpdated;
